import {
  SET_PROFILES,
  SET_SELECTED_PROFILE,
  UPDATE_PROFILE_HOOK,
  UPDATE_PROFILE_ACCESS_STATUS,
  ADD_IMPORTED_PROFILE
} from '../actions';
import _ from 'lodash';
const initialState = {
  loading: false,
  profiles: [],
  selectedProfile: {},
  profileHook: {}
}

const handleProfileReducerCases = (state = initialState, { type, payload }) => {
  let updatedProfiles;

  switch (type) {

    case UPDATE_PROFILE_ACCESS_STATUS:
      updatedProfiles = _.cloneDeep(state.profiles);
      updatedProfiles.forEach(profile => {
        if (profile.profileId === payload.id) {
          profile.isLocked = payload.lockStatus;
        }
      });
      return { ...state, profiles: updatedProfiles };

    case SET_PROFILES:
      return { ...state, loading: false, profiles: payload };

    case SET_SELECTED_PROFILE:
      if (typeof payload !== 'object') {
        const selectedProfile = { ...state }.profiles.find(profile => profile.profileId === payload);
        return { ...state, selectedProfile };
      }
      else {
        return { ...state, payload };
      }

    case UPDATE_PROFILE_HOOK:
      return { ...state, profileHook: payload }

    case ADD_IMPORTED_PROFILE:
      updatedProfiles = _.cloneDeep(state.profiles);
      updatedProfiles.push(payload);
      return { ...state, profiles: updatedProfiles };

    default:
      return state
  }
}

export default handleProfileReducerCases;
